/**
 * Campaign Hero Banner — picks the matching segment variant, swaps CRM weekly
 * creatives, and runs the week-4 countdown when configured.
 */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function parseDate(iso) {
    if (!iso) return null;
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  function resolveWeek(config, now) {
    var w1Start = parseDate(config.week1Start);
    var w23Start = parseDate(config.week23Start);
    var w4Start = parseDate(config.week4Start);
    var w4End = parseDate(config.week4End);
    if (!w1Start || !w23Start || !w4Start) return 'w1';

    if (w4End && now > w4End) return 'w4';
    if (now >= w4Start) return 'w4';
    if (now >= w23Start) return 'w23';
    if (now >= w1Start) return 'w1';
    return 'w1';
  }

  function getHeroI18n(root) {
    var el = root && root.hasAttribute && root.hasAttribute('data-campaign-hero-banner')
      ? root
      : root && root.closest
        ? root.closest('[data-campaign-hero-banner]')
        : null;
    el = el || document.querySelector('[data-campaign-hero-banner]');

    var lang = '';
    try {
      lang = String(
        (window.localeInfo && localeInfo.language) ||
          document.documentElement.getAttribute('lang') ||
          ''
      ).toLowerCase();
    } catch (e) {}

    var fallback = {
      upTo: 'Bis zu',
      save: 'sparen',
      discount: 'Rabatt',
      discountUpper: 'RABATT',
      onFirstOrder: 'auf die 1. Bestellung',
      percentOffEverything: 'RABATT AUF ALLES!',
      codeCopied: 'Code kopiert',
      codeLabel: 'CODE',
    };
    if (lang.indexOf('en') === 0) {
      fallback = {
        upTo: 'Up to',
        save: 'off',
        discount: 'discount',
        discountUpper: 'OFF',
        onFirstOrder: 'on your 1st order',
        percentOffEverything: 'OFF EVERYTHING!',
        codeCopied: 'Code copied',
        codeLabel: 'CODE',
      };
    } else if (lang.indexOf('es') === 0) {
      fallback = {
        upTo: 'Hasta',
        save: 'dto.',
        discount: 'descuento',
        discountUpper: 'DTO.',
        onFirstOrder: 'en el 1.er pedido',
        percentOffEverything: 'DTO. EN TODO!',
        codeCopied: 'Código copiado',
        codeLabel: 'CÓDIGO',
      };
    }

    if (!el) return fallback;
    return {
      upTo: el.getAttribute('data-i18n-up-to') || fallback.upTo,
      save: el.getAttribute('data-i18n-save') || fallback.save,
      discount: el.getAttribute('data-i18n-discount') || fallback.discount,
      discountUpper: el.getAttribute('data-i18n-discount-upper') || fallback.discountUpper,
      onFirstOrder: el.getAttribute('data-i18n-on-first-order') || fallback.onFirstOrder,
      percentOffEverything:
        el.getAttribute('data-i18n-percent-off-everything') || fallback.percentOffEverything,
      codeCopied: el.getAttribute('data-i18n-code-copied') || fallback.codeCopied,
      codeLabel: el.getAttribute('data-i18n-code-label') || fallback.codeLabel,
    };
  }

  function resolveBadgeText(content, panel, root) {
    content = content || {};
    var t = getHeroI18n(root || panel);
    var fromSegment = String(content.product_badge_text || content.discount_label || '').trim();
    if (fromSegment) return fromSegment;

    var mode = String(content.discount_mode || '').toLowerCase();
    var pct = content.discount_percent;
    if (mode !== 'tiered' && pct != null && Number(pct) > 0) {
      return '-' + Math.round(Number(pct)) + '% ' + t.save;
    }

    if (mode === 'tiered') {
      var high = content.tier_percent_high;
      if (high != null && Number(high) > 0) {
        return t.upTo + ' ' + Math.round(Number(high)) + '%';
      }
    }

    return panel.getAttribute('data-badge-override') || '';
  }

  function parseBadge(text) {
    var raw = String(text || '').trim();
    if (!raw) return null;
    var lower = raw.toLowerCase();
    var match = raw.match(/(-?\s*\d+)\s*%/);
    var percent = match ? match[1].replace(/\s+/g, '') + '%' : raw;
    if (percent.charAt(0) !== '-' && /^\d/.test(percent)) percent = '-' + percent;
    var isBisZu =
      lower.indexOf('bis zu') !== -1 ||
      lower.indexOf('up to') !== -1 ||
      lower.indexOf('hasta') !== -1 ||
      lower.indexOf('save up to') !== -1;
    var isSparen =
      (lower.indexOf('sparen') !== -1 ||
        lower.indexOf('save') !== -1 ||
        lower.indexOf(' off') !== -1 ||
        /(^|\s)off(\s|$)/.test(lower) ||
        lower.indexOf('dto') !== -1) &&
      !isBisZu;
    return {
      label: raw,
      percent: percent,
      showUpTo: isBisZu,
      showSparen: isSparen,
    };
  }

  function applyBadge(root, text) {
    var badge = root.querySelector('[data-campaign-hero-badge]');
    if (!badge) return;
    var t = getHeroI18n(root);
    var uptoEl = badge.querySelector('[data-campaign-hero-badge-upto]');
    var percentEl = badge.querySelector('[data-campaign-hero-badge-percent]');
    var suffixEl = badge.querySelector('[data-campaign-hero-badge-suffix]');
    var parsed = parseBadge(text);
    if (!parsed) {
      badge.hidden = true;
      return;
    }
    badge.hidden = false;
    badge.removeAttribute('hidden');
    if (percentEl) percentEl.textContent = parsed.percent;
    if (uptoEl) {
      // Prefer label baked into the element by Liquid (locale-aware), then section i18n.
      var uptoLabel =
        (uptoEl.getAttribute('data-i18n-label') || '').trim() ||
        t.upTo ||
        (uptoEl.textContent || '').trim();
      uptoEl.textContent = uptoLabel;
      uptoEl.hidden = !parsed.showUpTo;
      if (parsed.showUpTo) uptoEl.removeAttribute('hidden');
    }
    if (suffixEl) {
      var saveLabel =
        (suffixEl.getAttribute('data-i18n-label') || '').trim() ||
        t.save ||
        (suffixEl.textContent || '').trim();
      suffixEl.textContent = saveLabel;
      suffixEl.hidden = !parsed.showSparen;
      if (parsed.showSparen) suffixEl.removeAttribute('hidden');
    }
  }

  function syncSaleWidth(root) {
    var cta = root.querySelector('[data-campaign-hero-cta].campaign-hero-banner__cta--match-sale');
    if (!cta) {
      root.style.removeProperty('--campaign-hero-sale-width');
      return;
    }

    var measureEl =
      root.querySelector('.campaign-hero-banner__title-img') ||
      root.querySelector('[data-campaign-hero-sale]');

    if (!measureEl) {
      root.style.removeProperty('--campaign-hero-sale-width');
      return;
    }

    var width = Math.ceil(measureEl.getBoundingClientRect().width);
    if (width > 0) root.style.setProperty('--campaign-hero-sale-width', width + 'px');
    else root.style.removeProperty('--campaign-hero-sale-width');
  }

  function applyWeeklyMedia(panel, week) {
    panel.querySelectorAll('[data-campaign-hero-week]').forEach(function (el) {
      var w = el.getAttribute('data-campaign-hero-week');
      var on = w === week;
      el.hidden = !on;
      if (on) el.removeAttribute('hidden');
    });
  }

  function buildCodeOffer(content, root) {
    var t = getHeroI18n(root);
    var sub = String((content && content.collection_banner_subtext) || '').trim();
    if (sub && /rabatt|discount|descuento|off/i.test(sub) && sub.indexOf('·') === -1 && sub.indexOf('CODE') === -1) {
      return sub.replace(/^\s*bis\s*zu\s+/i, '').replace(/^\s*up\s*to\s+/i, '').replace(/^\s*hasta\s+/i, '').trim();
    }

    var label = String(
      (content && (content.discount_label || content.product_badge_text || content.selector_tag_text)) || ''
    ).trim();
    var match = label.match(/(-?\s*\d+)\s*%/);
    var percent = match ? match[1].replace(/\s+/g, '') + '%' : '';
    if (percent && percent.charAt(0) !== '-') percent = '-' + percent;

    if (percent) {
      return percent + ' ' + t.percentOffEverything;
    }

    return (sub || label || '').replace(/^\s*bis\s*zu\s+/i, '').replace(/^\s*up\s*to\s+/i, '').replace(/^\s*hasta\s+/i, '').trim();
  }

  function buildMetaCodeOffer(content, root) {
    var t = getHeroI18n(root);
    var percent = content && content.discount_percent != null ? Number(content.discount_percent) : NaN;
    var title = !isNaN(percent) && percent > 0 ? Math.round(percent) + '% ' + t.discount : '';
    var note = t.onFirstOrder;

    var label = String((content && content.discount_label) || '').trim();
    if (label) {
      var parts = label.split('|');
      if (parts.length >= 2) {
        title = parts[0].trim() || title;
        note = parts[1].trim() || note;
      } else {
        var match = label.match(/^(\d+\s*%\s*(?:Rabatt|discount|descuento|off))\s+(.+)$/i);
        if (match) {
          title = Math.round(percent) > 0 ? Math.round(percent) + '% ' + t.discount : match[1].replace(/\s+/g, ' ').trim();
          note = match[2].trim();
        } else if (!title && /%/.test(label)) {
          title = label.replace(/^-/, '').trim();
          if (!/rabatt|discount|descuento|off/i.test(title)) title = title + ' ' + t.discount;
        }
      }
    }

    return { title: title, note: note };
  }

  function isHomepageHero(root) {
    return !!(root && root.classList.contains('campaign-hero-banner--home'));
  }

  function applyHomepageMinimal(root, panel) {
    if (!isHomepageHero(root)) return;

    panel.querySelectorAll(
      '[data-campaign-hero-code], [data-campaign-hero-countdown], [data-campaign-hero-deal-pills], [data-campaign-hero-tiers], [data-campaign-hero-audience]'
    ).forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
    });

    root.querySelectorAll('[data-campaign-hero-countdown]').forEach(function (wrap) {
      if (wrap._cdTimer) clearInterval(wrap._cdTimer);
    });
  }

  function applyCode(panel, content) {
    var root = panel.closest('[data-campaign-hero-banner]');
    if (isHomepageHero(root)) {
      panel.querySelectorAll('[data-campaign-hero-code]').forEach(function (el) {
        el.hidden = true;
        el.setAttribute('hidden', '');
      });
      return;
    }

    var code = content.discount_code || panel.getAttribute('data-fallback-code') || '';
    var layout = String(panel.getAttribute('data-layout') || '').toLowerCase();
    var isCrmCodeLayout = layout === 'crm_weekly' || layout === 'crm_deal';
    var isTiered = content.discount_mode === 'tiered';
    var offer = buildCodeOffer(content, root);
    var metaOffer = buildMetaCodeOffer(content, root);
    var t = getHeroI18n(root);
    var hover = content.code_hover_text || t.codeCopied;

    panel.querySelectorAll('[data-campaign-hero-code]').forEach(function (el) {
      // Flat CRM + deal layouts always show the copy-code bar when a code exists.
      // Meta / badge layouts show the code box when a code exists and segment is not tiered.
      if (!code || (!isCrmCodeLayout && isTiered)) {
        el.hidden = true;
        return;
      }

      el.hidden = false;
      el.removeAttribute('hidden');
      el.setAttribute('data-code', code);
      if (content.discount_percent != null) {
        el.setAttribute('data-discount-percent', String(content.discount_percent));
      }

      var valueEl = el.querySelector('[data-campaign-hero-code-value]');
      if (valueEl) valueEl.textContent = code;

      var isTieredBox = el.getAttribute('data-code-style') === 'tiered';
      if (isTieredBox) {
        var lowPct = content.tier_percent_low != null ? content.tier_percent_low : 30;
        var highPct = content.tier_percent_high != null ? content.tier_percent_high : 35;
        var threshold = content.tier_threshold != null ? content.tier_threshold : 150;
        var lowEl = el.querySelector('[data-campaign-hero-code-tier-low]');
        var highEl = el.querySelector('[data-campaign-hero-code-tier-high]');
        var thEls = el.querySelectorAll(
          '[data-campaign-hero-code-tier-threshold], [data-campaign-hero-code-tier-threshold-ab]'
        );
        if (lowEl) lowEl.textContent = String(lowPct);
        if (highEl) highEl.textContent = String(highPct);
        thEls.forEach(function (node) {
          node.textContent = String(threshold);
        });
      } else {
        var offerEl = el.querySelector('[data-campaign-hero-code-offer]');
        if (offerEl) offerEl.textContent = offer;

        var titleEl = el.querySelector('[data-campaign-hero-code-offer-title]');
        if (titleEl) titleEl.textContent = metaOffer.title;

        var noteEl = el.querySelector('[data-campaign-hero-code-offer-note]');
        if (noteEl && metaOffer.note) noteEl.textContent = metaOffer.note;

        var captionEl = el.querySelector('[data-campaign-hero-code-caption]');
        if (captionEl) captionEl.textContent = 'Dein Code';
      }

      var copiedEl = el.querySelector('[data-campaign-hero-code-copied]');
      if (copiedEl) copiedEl.textContent = hover;
    });

    if (isCrmCodeLayout && code) {
      panel.querySelectorAll('[data-campaign-hero-deal-pills]').forEach(function (el) {
        el.hidden = true;
      });
    }
  }

  function bindCodeCopy(root) {
    if (root._campaignHeroCodeBound) return;
    root._campaignHeroCodeBound = true;

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-campaign-hero-code]');
      if (!btn || !root.contains(btn)) return;

      var code = btn.getAttribute('data-code') || '';
      if (!code) return;

      event.preventDefault();

      var done = function () {
        var copied = btn.querySelector('[data-campaign-hero-code-copied]');
        var text = btn.querySelector('.campaign-hero-banner__code-strip-text');
        var icon = btn.querySelector('.campaign-hero-banner__code-strip-icon');
        var header = btn.querySelector('.campaign-hero-banner__code-box-header');
        var tiers = btn.querySelector('.campaign-hero-banner__code-box-tiers');
        var metaParts = btn.querySelectorAll(
          '.campaign-hero-banner__code-box-offer, .campaign-hero-banner__code-box-divider, .campaign-hero-banner__code-box-code'
        );
        if (copied) {
          copied.hidden = false;
          copied.removeAttribute('hidden');
        }
        if (text) text.setAttribute('hidden', '');
        if (icon) icon.setAttribute('hidden', '');
        if (header) header.setAttribute('hidden', '');
        if (tiers) tiers.setAttribute('hidden', '');
        metaParts.forEach(function (el) {
          el.setAttribute('hidden', '');
        });
        btn.classList.add('is-copied');

        window.setTimeout(function () {
          if (copied) {
            copied.hidden = true;
            copied.setAttribute('hidden', '');
          }
          if (text) text.removeAttribute('hidden');
          if (icon) icon.removeAttribute('hidden');
          if (header) header.removeAttribute('hidden');
          if (tiers) tiers.removeAttribute('hidden');
          metaParts.forEach(function (el) {
            el.removeAttribute('hidden');
          });
          btn.classList.remove('is-copied');
        }, 1600);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }

      var percent = parseFloat(btn.getAttribute('data-discount-percent') || '') || null;
      document.dispatchEvent(
        new CustomEvent('campaign:code-applied', {
          detail: { code: code, percent: percent, source: 'campaign-hero-banner', element: btn },
        })
      );
    });
  }

  function isReturningCustomerSegment(segmentKey, panel) {
    var key = String(segmentKey || '').toLowerCase();
    if (key === 'meta_rc' || key === 'google_rc') return true;
    var layout = String((panel && panel.getAttribute('data-layout')) || '').toLowerCase();
    return layout === 'hero_badge_only';
  }

  function applyReturningCustomerMinimal(panel, segmentKey) {
    if (!isReturningCustomerSegment(segmentKey, panel)) return;

    panel.querySelectorAll('[data-campaign-hero-tiers]').forEach(function (el) {
      el.hidden = true;
    });
    // Keep Meta / paid-social code box visible for RC segments.
    panel.querySelectorAll('[data-campaign-hero-deal-pills]').forEach(function (el) {
      el.hidden = true;
    });
    panel.querySelectorAll('[data-campaign-hero-countdown]').forEach(function (el) {
      el.hidden = true;
    });
    panel.querySelectorAll('[data-campaign-hero-cta], .campaign-hero-banner__cta, .campaign-hero-banner__cta-row').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
      el.style.display = 'none';
    });
  }

  function applyInfluencerAudience(panel) {
    var strip = panel.querySelector('[data-campaign-hero-audience]');
    if (!strip) return;
    var root = panel.closest('[data-campaign-hero-banner]');
    var layout = String(panel.getAttribute('data-layout') || '').toLowerCase();
    if (layout !== 'influencer' || isHomepageHero(root)) {
      strip.hidden = true;
      return;
    }
    strip.hidden = false;
    strip.removeAttribute('hidden');

    // Collection influencer: audience tier box only — no CTA row underneath.
    panel.querySelectorAll('[data-campaign-hero-cta], .campaign-hero-banner__cta-row').forEach(function (el) {
      el.hidden = true;
      el.setAttribute('hidden', '');
      el.style.display = 'none';
    });
  }

  function applyTiers(panel, content) {
    var strip = panel.querySelector('[data-campaign-hero-tiers]');
    if (!strip) return;
    var root = panel.closest('[data-campaign-hero-banner]');
    if (root && root.getAttribute('data-hide-tiers') === 'true') {
      strip.hidden = true;
      return;
    }
    var layout = String(panel.getAttribute('data-layout') || '').toLowerCase();
    // CRM weekly / deal use the copy-code strip; RC badge-only has no discount strip.
    if (layout === 'crm_weekly' || layout === 'crm_deal' || layout === 'hero_badge_only') {
      strip.hidden = true;
      return;
    }
    var isTiered = content.discount_mode === 'tiered';
    if (!isTiered) {
      strip.hidden = true;
      return;
    }
    var low = content.tier_percent_low != null ? content.tier_percent_low : 25;
    var high = content.tier_percent_high != null ? content.tier_percent_high : 30;
    var threshold = content.tier_threshold != null ? content.tier_threshold : 99;
    var lowEl = panel.querySelector('[data-campaign-hero-tier-low]');
    var highEl = panel.querySelector('[data-campaign-hero-tier-high]');
    var thEls = panel.querySelectorAll(
      '[data-campaign-hero-tier-threshold], [data-campaign-hero-tier-threshold-ab]'
    );
    if (lowEl) lowEl.textContent = String(low);
    if (highEl) highEl.textContent = String(high);
    thEls.forEach(function (el) {
      el.textContent = String(threshold);
    });
    strip.hidden = false;
    strip.removeAttribute('hidden');

    // Prefer tier strip over deal pills when both exist.
    panel.querySelectorAll('[data-campaign-hero-deal-pills]').forEach(function (el) {
      el.hidden = true;
    });
  }

  function startCountdown(panel, endIso) {
    var wrap = panel.querySelector('[data-campaign-hero-countdown]');
    if (!wrap) return;
    var end = parseDate(endIso);
    if (!end) {
      wrap.hidden = true;
      return;
    }

    var daysEl = wrap.querySelector('[data-cd-days]');
    var hoursEl = wrap.querySelector('[data-cd-hours]');
    var minsEl = wrap.querySelector('[data-cd-mins]');
    var secsEl = wrap.querySelector('[data-cd-secs]');

    function tick() {
      var diff = end.getTime() - Date.now();
      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    wrap.hidden = false;
    wrap.removeAttribute('hidden');
    tick();
    if (wrap._cdTimer) clearInterval(wrap._cdTimer);
    wrap._cdTimer = setInterval(tick, 1000);
  }

  function stopCountdowns(root) {
    root.querySelectorAll('[data-campaign-hero-countdown]').forEach(function (wrap) {
      if (wrap._cdTimer) clearInterval(wrap._cdTimer);
      wrap.hidden = true;
    });
  }

  function pickPanel(root, segmentKey) {
    var panels = root.querySelectorAll('[data-campaign-hero-variant]');
    var fallback = null;
    var match = null;
    panels.forEach(function (panel) {
      var keys = (panel.getAttribute('data-segment-keys') || '')
        .split(',')
        .map(function (k) {
          return k.trim().toLowerCase();
        })
        .filter(Boolean);
      var isDefault = panel.getAttribute('data-is-default') === 'true';
      if (isDefault && !fallback) fallback = panel;
      if (segmentKey && keys.indexOf(String(segmentKey).toLowerCase()) !== -1) {
        match = panel;
      }
    });
    return match || fallback || panels[0] || null;
  }

  function showPanel(root, panel) {
    root.querySelectorAll('[data-campaign-hero-variant]').forEach(function (el) {
      var on = el === panel;
      el.hidden = !on;
      if (on) el.removeAttribute('hidden');
      el.classList.toggle('is-active', on);
    });
  }

  function activate(root, payload) {
    var configEl = root.querySelector('[data-campaign-hero-config]');
    var config = {};
    try {
      config = configEl ? JSON.parse(configEl.textContent) : {};
    } catch (e) {}

    var segmentKey = (payload && payload.key) || '';
    var content = (payload && payload.content) || {};
    var panel = pickPanel(root, segmentKey);
    if (!panel) return;

    showPanel(root, panel);
    stopCountdowns(root);

    var weekly = panel.getAttribute('data-weekly') === 'true';
    var week = weekly ? resolveWeek(config, new Date()) : 'w1';
    root.setAttribute('data-active-week', week);
    root.setAttribute('data-active-segment', segmentKey || 'default');

    if (weekly && !isHomepageHero(root)) {
      applyWeeklyMedia(panel, week);
      var countdown = panel.getAttribute('data-show-countdown') === 'true';
      if (countdown && week === 'w4') {
        startCountdown(panel, config.week4End || config.countdownEnd);
      }
    }

    applyCode(panel, content);
    applyTiers(panel, content);
    applyInfluencerAudience(panel);
    applyReturningCustomerMinimal(panel, segmentKey);
    applyHomepageMinimal(root, panel);
    enhanceCampaignCtas(panel);

    if (panel.getAttribute('data-hide-badge') === 'true') {
      applyBadge(panel, '');
    } else {
      applyBadge(panel, resolveBadgeText(content, panel, root));
    }

    window.requestAnimationFrame(function () {
      syncSaleWidth(panel);
    });

    var titleImg = panel.querySelector('.campaign-hero-banner__title-img');
    if (titleImg && !titleImg.complete) {
      titleImg.addEventListener(
        'load',
        function () {
          syncSaleWidth(panel);
        },
        { once: true }
      );
    }
  }

  function withCampaignScrollParams(href) {
    if (!href || href === '#') {
      return '/collections/mybacs-produkte-by-goal?filter.p.m.custom.filter_by_goal=Darm+%26+Verdauung&campaign_scroll=1';
    }
    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname.indexOf('/collections/') === -1) return href;
      if (!url.searchParams.has('filter.p.m.custom.filter_by_goal')) {
        url.searchParams.set('filter.p.m.custom.filter_by_goal', 'Darm & Verdauung');
      }
      url.searchParams.set('campaign_scroll', '1');
      return url.pathname + url.search + (url.hash || '');
    } catch (err) {
      return href;
    }
  }

  function enhanceCampaignCtas(root) {
    root.querySelectorAll('[data-campaign-hero-cta][data-campaign-scroll-products]').forEach(function (cta) {
      cta.setAttribute('href', withCampaignScrollParams(cta.getAttribute('href') || ''));
    });
  }

  function bindCtaScrollHint(root) {
    if (root._campaignHeroCtaScrollBound) return;
    root._campaignHeroCtaScrollBound = true;

    enhanceCampaignCtas(root);

    root.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-campaign-hero-cta][data-campaign-scroll-products]');
      if (!cta || !root.contains(cta)) return;

      var nextHref = withCampaignScrollParams(cta.getAttribute('href') || '');
      cta.setAttribute('href', nextHref);

      try {
        sessionStorage.setItem('campaignScrollToProducts', '1');
      } catch (e) {}

      // Already on the target collection → scroll in place (no full reload needed).
      try {
        var url = new URL(nextHref, window.location.origin);
        if (url.pathname === window.location.pathname) {
          event.preventDefault();
          if (url.search && url.search !== window.location.search) {
            window.history.replaceState({}, '', url.pathname + url.search + (url.hash || ''));
          }
          if (
            window.CampaignSegmentation &&
            typeof window.CampaignSegmentation.scrollToCollectionProducts === 'function'
          ) {
            window.CampaignSegmentation.scrollToCollectionProducts();
          } else {
            var target =
              document.getElementById('ProductGridContainer') ||
              document.getElementById('product-grid');
            if (target) {
              var top = target.getBoundingClientRect().top + window.scrollY - 80;
              window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
            }
          }
        }
      } catch (err) {}
    });
  }

  function boot(root) {
    bindCodeCopy(root);
    bindCtaScrollHint(root);

    function fromPayload(payload) {
      activate(root, payload || {});
    }

    if (window.CampaignSegmentation && CampaignSegmentation.isReady()) {
      fromPayload(CampaignSegmentation.get());
    } else {
      fromPayload({ key: '', content: {} });
    }

    document.addEventListener('campaign:segment-resolved', function (event) {
      fromPayload(event.detail);
    });

    window.addEventListener('resize', function () {
      var active = root.querySelector('[data-campaign-hero-variant].is-active');
      if (active) syncSaleWidth(active);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-campaign-hero-banner]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
